import { render, staticRenderFns } from "./AcoesHabilitar.vue?vue&type=template&id=04799ef4&scoped=true"
import script from "./AcoesHabilitar.vue?vue&type=script&lang=js"
export * from "./AcoesHabilitar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04799ef4",
  null
  
)

export default component.exports